/**
 * Framework documentation: https://vue-i18n.intlify.dev/`
 */

import { createI18n } from 'vue-i18n';
import enMessages from './locales/en.json';
import ruMessages from './locales/ru.json';
import { en as enVuetify } from 'vuetify/locale';
import { ru as ruVuetify } from 'vuetify/locale';
import enMessagesVueComponents from '@intec/vue-components/locales/en.json'
import ruMessagesVueComponents from '@intec/vue-components/locales/ru.json'
import { getRuMessages } from '@/plugins/i18n/utils';

// Основная схема ресурсов
type MessageSchema = typeof enMessages

const messages = {
  en: {
    $vuetify: {
      ...enVuetify,
    },
    ...enMessages,
    ...enMessagesVueComponents
  },
  ru: {
    $vuetify: {
      ...ruVuetify,
    },
    ...getRuMessages(ruMessages),
    ...getRuMessages(ruMessagesVueComponents)
  }
}

export default createI18n<[MessageSchema], 'en'>({
  fallbackLocale: 'ru',
  locale: 'en',
  messages,
})
